export function hasSufficientData(data, months = 6, minPoints = 2, referenceDate = Date.now()) {
  const MS_PER_MONTH = 30.44 * 24 * 60 * 60 * 1000;
  const cutoff = referenceDate - months * MS_PER_MONTH;

  const count = data.reduce((acc, item) => {
    const time = (item.date instanceof Date)
      ? item.date.getTime()
      : new Date(item.date).getTime();

    return acc + (time >= cutoff ? 1 : 0);
  }, 0);

  return count >= minPoints;
}


// WEBPACK FOOTER //
// ./src/helpers/chart.helpers.js